// const base = import(
//   /* webpackInclude: /^(de|en|es|fr|it|nl|no|pl|pt-BR|pt|fi|sv|ko|ru|zh|zh-Hans|zh-Hant|ja)\.js/ */
//   /* webpackMode: "lazy-once" */
//   /* webpackChunkName: "i18n-base" */
//   `@angular/common/locales/${key}`).then(m => m[basePkg]);

// const extra = import(
//   /* webpackInclude: /^(de|en|es|fr|it|nl|no|pl|pt-BR|pt|fi|sv|ko|ru|zh|zh-Hans|zh-Hant|ja)\.js/ */
//   /* webpackMode: "lazy-once" */
//   /* webpackChunkName: "i18n-extra" */
//   `@angular/common/locales/extra/${key}`).then(m => m[extraPkg]);

// import { differentLocales } from '@abp/ng.core';
// export function registerLocale(locale: string) {
//   return import(
//     /* webpackChunkName: "_locale-[request]"*/
//     /* webpackInclude: /[/\\](en|fr).js/ */
//     /* webpackExclude: /[/\\]global|extra/ */
//     `@angular/common/locales/${differentLocales[locale] || locale}.js`
//   )
// }

import { differentLocales } from '@abp/ng.core';
import { defaultLocalErrorHandlerFn } from '@abp/ng.core/locale';

function registerLocale({ cultureNameLocaleFileMap = {}, errorHandlerFn = defaultLocalErrorHandlerFn, } = {}) {
    return (locale) => {
        cultureNameLocaleFileMap = { ...differentLocales, ...cultureNameLocaleFileMap };
        const localePath = `/locales/${cultureNameLocaleFileMap[locale] || locale}`;
        return new Promise((resolve, reject) => {
            return import(
            /* webpackMode: "lazy-once" */
            /* webpackChunkName: "_locale-[request]"*/
            /* webpackInclude: /[/\\](ar|ar-AE|de-DE|en|en-GB|es|fr|it|zh-Hans)\.(mjs|js)$/ */
            /* webpackExclude: /[/\\]global|extra/ */
            `@angular/common${localePath}`)
                .then(val => {
                let module = val;
                while (module.default) {
                    module = module.default;
                }
                resolve({ default: module });
            })
                .catch(error => {
                errorHandlerFn({
                    resolve,
                    reject,
                    error,
                    locale,
                });
            });
        });
    };
}

/**
 * Generated bundle index. Do not edit.
 */

export { registerLocale };
//# sourceMappingURL=volo-abp.ng.language-management-locale.mjs.map
